import ratingReducer from './ratingReducer';
export * from './RatingAction';
export default ratingReducer;